import React from 'react';
import Card from '../../ui/Card';
import { AlertTriangleIcon, TrendingDownIcon, XCircleIcon } from 'lucide-react';
const WarningFlags: React.FC = () => {
  const warnings = [{
    type: 'Slipping Orders',
    count: 3,
    value: '₹185 Cr',
    icon: <AlertTriangleIcon size={16} data-id="element-9222" />,
    color: 'text-yellow-600 bg-yellow-50'
  }, {
    type: 'High Returns',
    count: 2,
    value: '₹42 Cr',
    icon: <XCircleIcon size={16} data-id="element-9223" />,
    color: 'text-red-600 bg-red-50'
  }, {
    type: 'Negative Margins',
    count: 1,
    value: '₹28 Cr',
    icon: <TrendingDownIcon size={16} data-id="element-9224" />,
    color: 'text-red-600 bg-red-50'
  }];
  return <Card className="p-6" data-id="element-9225">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-9226">
        Early Warning Flags
      </h3>
      <div className="space-y-3" data-id="element-9227">
        {warnings.map((warning, index) => <div key={index} className={`p-3 rounded-lg ${warning.color.split(' ')[1]}`} data-id="element-9228">
            <div className="flex items-start justify-between" data-id="element-9229">
              <div className="flex items-start" data-id="element-9230">
                <div className={`${warning.color.split(' ')[0]} mt-0.5 mr-2`} data-id="element-9231">
                  {warning.icon}
                </div>
                <div data-id="element-9232">
                  <div className="text-sm font-semibold text-gray-800" data-id="element-9233">
                    {warning.type}
                  </div>
                  <div className="text-xs text-gray-600 mt-0.5" data-id="element-9234">
                    {warning.count} {warning.count === 1 ? 'case' : 'cases'} •{' '}
                    {warning.value}
                  </div>
                </div>
              </div>
              <button className="text-xs text-blue-600 hover:text-blue-700 font-medium" data-id="element-9235">
                View
              </button>
            </div>
          </div>)}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-9236">
        <div className="text-xs text-gray-500 text-center" data-id="element-9237">
          Total Flagged: ₹255 Cr across 6 cases
        </div>
      </div>
    </Card>;
};
export default WarningFlags;